import request from '@/utils/request'


export function getArticleByTagUid(params) {
  return request({
    url: process.env.WEB_API + '/index/getArticleByTagUid',
    method: 'post',
    data: params
  })
}

export function getBlogByLevel(params) {
  return request({
    url: process.env.WEB_API + '/index/getBlogByLevel',
    method: 'get',
    params
  })
}

export function getNewBlog(params) {
  return request({
    url: process.env.WEB_API + '/index/getNewBlog',
    method: 'post',
    data: params
  })
}

export function getBlogByTime(params) {
  return request({
    url: process.env.WEB_API + '/index/getBlogByTime',
    method: 'get',
    params
  })
}

export function getHotBlog(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotBlog',
    method: 'post',
    data: params
  })
}

export function getHotTag(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotTag',
    method: 'get',
    params
  })
}

export function getHotBlogSort(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotBlogSort',
    method: 'get',
    params
  })
}




export function getExperienceByLevel(params) {
  return request({
    url: process.env.WEB_API + '/index/getExperienceByLevel',
    method: 'get',
    params
  })
}

export function getNewExperience(params) {
  return request({
    url: process.env.WEB_API + '/index/getNewExperience',
    method: 'post',
    data: params
  })
}

export function getExperienceByTime(params) {
  return request({
    url: process.env.WEB_API + '/index/getExperienceByTime',
    method: 'get',
    params
  })
}

export function getHotExperience(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotExperience',
    method: 'get',
    params
  })
}

export function getHotExperienceTag(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotExperienceTag',
    method: 'get',
    params
  })
}

export function getHotExperienceSort(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotExperienceSort',
    method: 'get',
    params
  })
}







export function getLink(params) {
  return request({
    url: process.env.WEB_API + '/index/getLink',
    method: 'get',
    params
  })
}

export function addLinkCount(params) {
  return request({
    url: process.env.WEB_API + '/index/addLinkCount',
    method: 'get',
    params
  })
}

export function getWebConfig(params) {
  return request({
    url: process.env.WEB_API + '/index/getWebConfig',
    method: 'get',
    params
  })
}

export function getWebNavbar(params) {
  return request({
    url: process.env.WEB_API + '/index/getWebNavbar',
    method: 'get',
    params
  })
}

export function recorderVisitPage(params) {
  return request({
    url: process.env.WEB_API + '/index/recorderVisitPage',
    method: 'get',
    params
  })
}

export function recorderBehavior(params) {
  return request({
    url: process.env.WEB_API + '/index/recorderBehavior',
    method: 'post',
    data: params
  })
}

export function getUserTopN(params) {
  return request({
    url: process.env.WEB_API + '/index/getUserTopN',
    method: 'post',
    data: params
  })
}

export function getVersionParams(params) {
  return request({
    url: process.env.WEB_API + '/index/getVersionParams',
    method: 'get',
    params
  })
}

 //获取首页热门工作标签ID
 export function getPopularJob(params) {
  return request({
    url: process.env.WEB_API + '/index/getPopularJob',
    method: 'get',
    params
  })
}

//获取首页工作活跃用户（承接者）
export function getPopularUndertaker(params) {
  return request({
    url: process.env.WEB_API + '/index/getPopularUndertaker',
    method: 'get',
    params
  })
}

//获取首页最高赏金工作
export function getHighestBountyJob(params) {
  return request({
    url: process.env.WEB_API + '/index/getHighestBountyJob',
    method: 'get',
    params
  })
}

export function getHighestBountyEndJob(params) {
  return request({
    url: process.env.WEB_API + '/index/getHighestBountyEndJob',
    method: 'get',
    params
  })
}

//获取首页最高赏金工作
export function getAllJobTag(params) {
  return request({
    url: process.env.WEB_API + '/index/getAllJobTag',
    method: 'get',
    params
  })
}




/**
 * 获取首页完结工作公告
 * @returns 
 */
export function getEndJobNotice() {
  return request({
    url: process.env.WEB_API + '/index/getEndJobNotice',
    method: 'get'
  })
}


/**
 * 获取首页中选工作公告
 * @returns 
 */
export function getSelectedJobNotice() {
  return request({
    url: process.env.WEB_API + '/index/getSelectedJobNotice',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js